<div
   class="container"
   [class.samwin-shape]="useSamwinShape"
   [class.round-shape]="useRoundShape"
   [class.show-presence-status]="showPresenceStatus"
   [samwebUserStatusClass]="statusInfo$ | async"
   [style.background-image]="avatarBackgroundStyle$ | async"
>
   <div class="content" fxLayoutAlign="center center">
      <fa-icon *ngIf="!(avatarUrl$ | async)" [fixedWidth]="true" [icon]="userIcon"></fa-icon>
   </div>
</div>
